import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useCrmAccess = () => {
  return useQuery({
    queryKey: ["crm-access"],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) return false;

      console.log("🔍 CRM Access Check for user:", session.user.id);

      const { data: role, error } = await supabase.rpc('get_user_role', {
        user_id: session.user.id
      });

      if (error) {
        console.error("❌ Error getting user role:", error);
        return false;
      }

      console.log("✅ User role:", role);

      // Check for partner record separately so partner access works as an add-on
      const { data: partner, error: partnerError } = await supabase
        .from('crm_partners')
        .select('id')
        .eq('user_id', session.user.id)
        .maybeSingle();

      if (partnerError) {
        console.error("❌ Error checking partner record:", partnerError);
      }

      // Allow CRM access to:
      // - Superusers (full access to all data)
      // - Internal staff (same surface as superuser, demo-only devices)
      // - Anyone with a partner record (partner-managed data)
      const hasAccess = role === 'superuser' || role === 'internal_staff' || !!partner;
      console.log("🔑 CRM Access granted:", hasAccess, { role, hasPartnerRecord: !!partner });

      return hasAccess;
    }
  });
};
